import { useContext } from 'react'
import { GlobalInformations } from '@/context/GlobalInformationsContext'

export const useGlobalInformations = () => useContext(GlobalInformations)
